var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:telegram",
    clipPath: "url(#clip0_25_514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0.00634766C22.0453 0.00634766 14.4094 3.169 8.78906 8.79307C3.16299 14.4194 0.00160992 22.0497 0 30.0063C0 37.9596 3.16406 45.5956 8.78906 51.2196C14.4094 56.8437 22.0453 60.0063 30 60.0063C37.9547 60.0063 45.5906 56.8437 51.2109 51.2196C56.8359 45.5956 60 37.9596 60 30.0063C60 22.0531 56.8359 14.4171 51.2109 8.79307C45.5906 3.169 37.9547 0.00634766 30 0.00634766Z",
    fill: "url(#paint0_linear_25_514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5791 29.6895C22.326 25.8795 28.1572 23.3676 31.0729 22.1538C39.4072 18.6884 41.1369 18.0865 42.2666 18.0661C42.5151 18.0621 43.0682 18.1235 43.4291 18.4153C43.7291 18.6614 43.8135 18.9942 43.8557 19.2279C43.8932 19.4613 43.9447 19.9934 43.9026 20.4087C43.4526 25.1524 41.4979 36.664 40.5041 41.9773C40.0869 44.2254 39.2572 44.9791 38.4557 45.0527C36.7119 45.213 35.3901 43.9015 33.7026 42.7957C31.0635 41.0646 29.5729 39.9874 27.0088 38.2985C24.0463 36.3466 25.9682 35.2737 27.6557 33.5205C28.0963 33.0616 35.7744 26.0796 35.9197 25.4463C35.9385 25.3671 35.9572 25.0718 35.7791 24.9162C35.6057 24.7601 35.3479 24.8135 35.1604 24.8557C34.8932 24.9157 30.6791 27.7038 22.5041 33.2196C21.3088 34.0418 20.226 34.4426 19.251 34.4215C18.1822 34.3985 16.1197 33.8159 14.5869 33.318C12.7119 32.7073 11.2166 32.3843 11.3479 31.347C11.4135 30.807 12.1588 30.2543 13.5791 29.6895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_514",
    x1: 3000,
    y1: 0.00634766,
    x2: 3000,
    y2: 6000.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.00634766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramm);
export default __webpack_public_path__ + "static/media/telegramm.2fa8950bb1fd1158555ae0362d8f69ef.svg";
export { ForwardRef as ReactComponent };